export default "__VITE_ASSET__CMBHXIux__"